import type { Product } from 'src/components/restructure/product/types/product'

const TARGET_BRANDS = new Set([
  'quechua',
  'kiprun',
  'kipsta',
  'nabaiji',
  'domyos',
])

const LINE_900_REGEX = /(?:^|[^0-9])900(?:[^0-9]|$)/

function normalizeText(value?: string) {
  return value?.toLowerCase().trim() ?? ''
}

function hasTargetBrand(brand?: string) {
  return TARGET_BRANDS.has(normalizeText(brand))
}

function hasLine900(product: Product) {
  const sources = [
    product.productName,
    product.linkText,
    product.productReference,
    ...(product.categories ?? []),
  ]

  return sources.some((source) => LINE_900_REGEX.test(normalizeText(source)))
}

export function isAuthorityBadgeEligible({ product }: { product: Product }) {
  return hasTargetBrand(product.brand) && hasLine900(product)
}
